export const excludedTaxRates: string[] = [
  'Email Credit Gift Cards',
  'Physical Credit Gift Cards',
  'Email Gift Cards',
  'Physical Gift Cards',
];
